const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Home = () => import(/* webpackChunkName: "home" */'@/components/pages/home/Home');
const Announcement = () => import(/* webpackChunkName: "home" */'@/components/pages/announcement/Announcement');
const AnnouncementDetail = () => import(/* webpackChunkName: "home" */'@/components/pages/announcement/AnnouncementDetail');
const AssetDetail = () => import(/* webpackChunkName: "home" */'@/components/pages/home/customer/AssetDetail');
const KnowledgeDetail = () => import(/* webpackChunkName: "home" */'@/components/pages/knowledgeManage/KnowledgeDetail');
const KnowledgeSearch = () => import(/* webpackChunkName: "home" */'@/components/pages/knowledgeManage/KnowledgeSearch');
const EventWorkflowDetail = () => import(/* webpackChunkName: "home" */'@/components/pages/home/customer/EventWorkflowDetail');
const EventCreatePage = () => import(/* webpackChunkName: "home" */'@/components/pages/home/customer/EventCreatePage');
const EventWorkbench = () => import(/* webpackChunkName: "home" */'@/components/pages/home/customer/EventWorkbench');

export default [
  {
    path: '/home',
    meta: {
      roles: []
    },
    component: Layout,
    children: [
      {
        path: '',
        name: 'home',
        meta: {
          roles: [],
          title: '主页',
          icon: 'home',
          anchor: true,
          activeMenu: '/home',
          componentName: 'Home',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            }
          ]
        },
        component: Home
      },
      {
        path: 'announcement',
        name: 'customerSearchAnnouncement',
        meta: {
          title: '公告管理',
          hidden: true,
          activeMenu: '/home',
          componentName: 'Announcement',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '公告列表',
              path: '/home/announcement-bench'
            }
          ]
        },
        component: Announcement
      },
      {
        path: '/announcement/:id',
        props: true,
        name: 'customerAnnouncementDetail',
        meta: {
          title: '公告详情',
          hidden: true,
          activeMenu: '/home',
          componentName: 'AnnouncementDetail',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '公告详情',
              path: '/home/announcement/:id'
            }
          ]
        },
        component: AnnouncementDetail
      },
      {
        path: '/edit-asset/:id',
        props: true,
        name: 'customerAssetDetail',
        meta: {
          title: '资产管理',
          hidden: true,
          activeMenu: '/home',
          componentName: 'AssetDetail',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '编辑资产',
              path: '/home/edit-asset/:id'
            }
          ]
        },
        component: AssetDetail
      },
      {
        path: '/knowledge/:id',
        props: true,
        name: 'customerKnowledgeDetail',
        meta: {
          title: '知识详情',
          hidden: true,
          activeMenu: '/home',
          componentName: 'KnowledgeDetail',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '知识详情',
              path: '/home/knowledge/:id'
            }
          ]
        },
        component: KnowledgeDetail
      },
      {
        path: 'edit-event-workflow/:id',
        props: true,
        name: 'editCustomerEventWorkflow',
        meta: {
          title: '请求详情',
          hidden: true,
          activeMenu: '/home',
          componentName: 'EventWorkflowDetail',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '请求详情',
              path: '/home/edit-event-workflow/:id'
            }
          ]
        },
        component: EventWorkflowDetail
      },
      {
        path: 'create-event-workflow',
        props: true,
        name: 'customerEventWorkflowCreate',
        meta: {
          title: '新建请求',
          hidden: true,
          activeMenu: '/home',
          componentName: 'EventCreatePage',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '新建请求',
              path: '/home/create-event-workflow'
            }
          ]
        },
        component: EventCreatePage
      },
      {
        path: 'edit-event-workflow/:id',
        props: true,
        name: 'customerEventWorkflowEdit',
        meta: {
          title: '编辑请求',
          hidden: true,
          activeMenu: '/home',
          componentName: 'EventCreatePage',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '编辑请求',
              path: '/home/edit-event-workflow/:id'
            }
          ]
        },
        component: EventCreatePage
      },
      {
        path: 'event-bench',
        name: 'customerEventBench',
        meta: {
          title: '我的请求',
          hidden: true,
          activeMenu: '/home',
          componentName: 'EventWorkbench',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '我的请求',
              path: '/home/event-bench'
            }
          ]
        },
        component: EventWorkbench
      },
      {
        path: '/knowledge-search',
        props: true,
        name: 'customerKnowledgeBench',
        meta: {
          title: '知识检索',
          hidden: true,
          activeMenu: '/home',
          componentName: 'KnowledgeSearch',
          breadcrumb: [
            {
              name: '主页',
              path: '/home'
            },
            {
              name: '知识检索',
              path: '/home/knowledge-search'
            }
          ]
        },
        component: KnowledgeSearch
      },
    ]
  },
];


// WEBPACK FOOTER //
// ./src/router/home.js